var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('h1',{ref:"pageTitle"},[_vm._v("Opportunities")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.jobs.length > 0)?_c('div',[_c('app-job-list',{attrs:{"jobs":_vm.jobs}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c894be2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobBoard/JobBoard.vue
// module id = 765
// module chunks = 0